export const AUTH_TOKEN_KEY = "token";

const INVALID_TOKEN_VALUES = new Set(["", "null", "undefined"]);

export function normalizeAuthToken(value) {
    if (typeof value !== "string") return null;

    const token = value.trim().replace(/^Bearer\s+/i, "");
    if (INVALID_TOKEN_VALUES.has(token.toLowerCase())) return null;

    return token;
}

export function isJwtToken(token) {
    const normalizedToken = normalizeAuthToken(token);
    if (!normalizedToken) return false;

    return normalizedToken.split(".").length === 3;
}

export function isJwtExpired(token) {
    const normalizedToken = normalizeAuthToken(token);
    if (!isJwtToken(normalizedToken)) return true;

    try {
        const payloadSegment = normalizedToken.split(".")[1];
        const base64 = payloadSegment.replace(/-/g, "+").replace(/_/g, "/");
        const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
        const payload = JSON.parse(window.atob(paddedBase64));

        return typeof payload.exp === "number" && payload.exp * 1000 <= Date.now();
    } catch (_error) {
        return true;
    }
}

export function getStoredAuthToken() {
    const token = normalizeAuthToken(localStorage.getItem(AUTH_TOKEN_KEY));
    return token && isJwtToken(token) && !isJwtExpired(token) ? token : null;
}
